import {useContext} from 'react';
import {View, ScrollView} from 'react-native';
import {Divider} from 'react-native-paper';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

import sy from '~/styles';

import {useDispatch} from '~/lib/hooks';
import {setShowDrawer, showLogoutDialog} from '~/actions';
import {
  Text,
  Checkbox,
  PrimaryButton,
  Drawer,
  PrivateText,
} from '~/components/controls';
import {
  DrawerHeader,
  DrawerTitle,
  DrawerSubtitle,
  DrawerContent,
} from '~/components/controls/Drawer';
import UserContext from '~/components/context/UserContext';
import withDimensions from '~/components/hoc/with-dimensions';

import LogoutIcon from '~/images/md-icons/logout_white/materialicons/18px.svg';

const SideDrawer = ({dimensions}) => {
  const dispatch = useDispatch();
  const {top} = useSafeAreaInsets();

  const {me} = useContext(UserContext);

  const {width} = dimensions.window;

  return (
    <Drawer
      onClose={() => dispatch(setShowDrawer(false))}
      style={{
        width: Math.max(Math.min(width - 56, 356), 256),
        paddingBottom: top,
      }}>
      <DrawerHeader style={{paddingBottom: 16}}>
        <DrawerTitle>
          <PrivateText style={sy.largePlus}>
            {me?.first_name} {me?.last_name}
          </PrivateText>
        </DrawerTitle>
        <DrawerSubtitle>
          <PrivateText style={[sy.smallPlus, {color: '#828282'}]}>
            {me?.email}
          </PrivateText>
        </DrawerSubtitle>
      </DrawerHeader>
      <DrawerContent>
        <Divider style={{backgroundColor: '#f2f2f2'}} />
        <ScrollView>
          <View style={[sy['p-4'], sy['gap-6']]}>
            <Text style={[sy.smallPlus, {color: '#828282'}]}>
              Leasemaatschappij(en)
            </Text>
            <View style={[sy['gap-6']]}>
              {me?.lessors
                ?.sort((a, b) => a.localeCompare(b))
                .map((lessor) => (
                  <View
                    key={lessor}
                    style={[sy['flex-row'], sy['items-center'], sy['gap-8']]}>
                    <Checkbox checked={true} disabled={true} />
                    <Text>{lessor}</Text>
                  </View>
                ))}
            </View>
          </View>
        </ScrollView>
      </DrawerContent>
      <View style={[sy['p-4'], sy['justify-center'], sy['items-center']]}>
        <View style={{width: 160}}>
          <PrimaryButton
            icon={<LogoutIcon />}
            onPress={() => {
              dispatch(setShowDrawer(false));
              dispatch(showLogoutDialog());
            }}>
            Uitloggen
          </PrimaryButton>
        </View>
      </View>
    </Drawer>
  );
};

export default withDimensions(SideDrawer);
